/**
 * Super Admin "view as" landing on the partner portal: `/view-as#code=...` (docs/specs/staff-view-as.md).
 * Public (outside PartnerGate): it creates the agency session, so it must work signed out.
 */
import { ViewAsRedeem } from '../../../shell/ViewAs';
import { useSurface } from '../kit/context';

export function ViewAsScreen() {
  const { t } = useSurface();
  return <ViewAsRedeem surface="partner" t={t} />;
}
